import request from '@/utils/request'


// 查询用户阅读记录列表
export function listUserRecord(query) {
  return request({
    url: '/user/user-record/list',
    method: 'get',
    params: query
  })
}

// 查询用户阅读记录分页
export function pageUserRecord(query) {
  return request({
    url: '/user/user-record/page',
    method: 'get',
    params: query
  })
}

// 查询用户阅读记录详细
export function getUserRecord(data) {
  return request({
    url: '/user/user-record/detail',
    method: 'get',
    params: data
  })
}

// 新增用户阅读记录
export function addUserRecord(data) {
  return request({
    url: '/user/user-record/add',
    method: 'post',
    data: data
  })
}

// 修改用户阅读记录
export function updateUserRecord(data) {
  return request({
    url: '/user/user-record/edit',
    method: 'post',
    data: data
  })
}

// 删除用户阅读记录
export function delUserRecord(data) {
  return request({
    url: '/user/user-record/delete',
    method: 'post',
    data: data
  })
}
